import { useState } from "react";

export interface PodcastSelectionInterface {
  channelId: number;
  value: number;
  label: string;
  color: string;
}

const lexFridmanPodcast: PodcastSelectionInterface = {
  channelId: 1,
  value: 1,
  label: "Lex Fridman Podcast",
  color: "blue",
};

const brianKeatingPodcast: PodcastSelectionInterface = {
  channelId: 2,
  value: 2,
  label: "Brian Keating: Into the Impossible",
  color: "red",
};

const jordanPetersonPodcast: PodcastSelectionInterface = {
  channelId: 3,
  value: 3,
  label: "Jordan Peterson Podcast",
  color: "green",
};

// sanjay's podcasts

const web3WithA16ZPodcast: PodcastSelectionInterface = {
  channelId: 2,
  value: 4,
  label: "Web3 with a16z crypto",
  color: "orange",
};

const oldManAndTheThree: PodcastSelectionInterface = {
  channelId: 3,
  value: 5,
  label: "The Old Man and the Three",
  color: "purple",
};

const aniPodcast: PodcastSelectionInterface = {
  channelId: 4,
  value: 6,
  label: "ANI Podcast with Smita Prakash",
  color: "red",
};

const thePrintPodcast: PodcastSelectionInterface = {
  channelId: 5,
  value: 7,
  label: "ThePrint",
  color: "pink",
};

const swayKaraSwisher: PodcastSelectionInterface = {
  channelId: 6,
  value: 8,
  label: "Sway with Kara Swisher",
  color: "brown",
};

const onWithKaraSwisher: PodcastSelectionInterface = {
  channelId: 7,
  value: 9,
  label: "On with Kara Swisher",
  color: "green",
};

const justinBradyShow: PodcastSelectionInterface = {
  channelId: 8,
  value: 10,
  label: "Justin Brady Show",
  color: "blue",
};

export function lexDemoPodcasts(): PodcastSelectionInterface[] {
  return [lexFridmanPodcast, brianKeatingPodcast, jordanPetersonPodcast];
}

export function sanjayPodcasts(): PodcastSelectionInterface[] {
  return [
    web3WithA16ZPodcast,
    oldManAndTheThree,
    aniPodcast,
    thePrintPodcast,
    swayKaraSwisher,
    onWithKaraSwisher,
  ];
}

export function justinBradyDemo(): PodcastSelectionInterface[] {
  return [
    justinBradyShow,
    lexFridmanPodcast,
    oldManAndTheThree,
    web3WithA16ZPodcast,
  ];
}

export function podcastSelectionStateVariables(
  initiallySelected: PodcastSelectionInterface[]
): [PodcastSelectionInterface[], (state: PodcastSelectionInterface[]) => void] {
  const [selectedPodcasts, setSelectedPodcasts] =
    useState<PodcastSelectionInterface[]>(initiallySelected);
  return [selectedPodcasts, setSelectedPodcasts];
}
